import { Component, OnDestroy, OnInit } from '@angular/core';
import { LayoutService } from 'app/core/services/layout/layout.service';
import { createBatchPaymentsMenuItems } from './batch-payments-navitems';

@Component({
  templateUrl: './batch-payments.component.html',
  styleUrls: ['./batch-payments.component.scss']
})
export class BatchPaymentsComponent implements OnInit, OnDestroy {

  constructor(
    private layoutService: LayoutService
  ) { }

  ngOnInit() {
    this.layoutService.updateMenu(createBatchPaymentsMenuItems());
    localStorage.setItem('pageType', 'batch-payments');
  }


  ngOnDestroy(): void {
    localStorage.removeItem('pageType');
  }
}
